import "core-js/modules/es.function.name.js";
export default function getUserInspectorLink(item) {
  if (!item.name) {
    return null;
  }
  return "/users?search=".concat(encodeURIComponent(item.name));
}